import { BehaviorSubject, Observable } from 'rxjs';

export class Store<T> {
  private _state: BehaviorSubject<T>;

  constructor(initialState?: T) {
    this._state = new BehaviorSubject(initialState);
  }

  public get state(): T {
    return this._state.value;
  }

  get state$(): Observable<T> {
    return this._state.asObservable();
  }

  setState(nextState: T): void {
    this._state.next(nextState);
  }
}



// WEBPACK FOOTER //
// ./ts/app/shared/store.ts